/**
 * Legacy `/admin` URL — redirect to canonical TanStack admin dashboard.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});
